import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  StyledSliderSectionContiner,
  StyledTourCard,
} from 'views/experience-module/MotorcycleTripView/components/MotorcycleToursSection/MotorcycleToursSection.styles';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import { prepareTourCardImageObject } from 'views/experience-module/MotorcycleTripView/utils/prepareTourCardImageObject';
import PATHS from 'lib/navigation/paths';
import { TOUR_TYPES } from 'lib/utils/CONSTANTS';

const MotorcycleToursSection = (props) => {
  const { title, description, tourCardItems } = props;
  const { isCrawler, deviceType } = useSelector((state) => state.globalData);
  return (
    <StyledSliderSectionContiner
      title={title}
      description={description}
      deskTopItems={4}
      showDots
      component="h3"
      descComponent="h3">
      {tourCardItems.map((item) => (
        <Box className="CarouselItem" key={item.id}>
          <StyledTourCard
            name={item.name}
            images={prepareTourCardImageObject(item.images)}
            tourType={item.type_name}
            startLocationName={item.start_location_name}
            startingPrice={
              item.starting_price !== null
                ? moneyFormat(Dinero(item.starting_price))
                : item.starting_price
            }
            daysCount={item.days_count}
            ssr={isCrawler}
            deviceType={deviceType}
            tourPath={
              item.type_identifier === TOUR_TYPES.SELF_DRIVE
                ? PATHS.selfDriveTour(item.slug)
                : PATHS.guidedTour(item.slug)
            }
            nameTypoComponent="h6"
          />
        </Box>
      ))}
    </StyledSliderSectionContiner>
  );
};
export { MotorcycleToursSection };
